import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';

const createSession = async (tillId) => {
  const response = await axios.post(`${API_BASE_URL}/api/cfd/sessions`, { tillId });
  return response.data;
};

const cfdService = {
  createSession,
};

export default cfdService;
